<template>
  <div class="col-12 px-0 m-0 col-custom-radius">
    <ul class="nav nav-tabs nav-justified border-0 mb-0">
      <li class="nav-item m-0" v-for="tab in tabs" :key="tab.value">
        <a 
          class="nav-link font-weight-bold py-3" 
          :class="{ 
            'active': value === tab.value, 
            'inactive-tab': value !== tab.value,
            'disabled-tab': tab.disabled
          }"
          @click="tab.disabled ? null : cambiarTab(tab.value)" 
          style="margin-bottom: 0px; overflow-wrap: break-word; word-break: break-word;"
        >
          {{ tab.label }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * /--------------------------/
 * COMPONENTE: TabsProvider 
 * /--------------------------/
 * 
 * Genera pestañas edge-to-edge con estilos atómicos unificados.
 * Ideal para colocar dentro del <template #custom-header> de un ModalProvider.
 * 
 * --- PROPS ---
 * @prop {Array} tabs 
 * Estructura esperada: [{ label: 'Título', value: 0, disabled: false }]
 * 
 * @prop {String|Number} value (v-model)
 * Controla qué pestaña está activa actualmente basado en el `value` de cada objeto tab.
 */
export default {
  name: 'TabsProvider',
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    tabs: {
      type: Array,
      required: true
    }
  },
  methods: {
    cambiarTab(val) {
      if (this.value !== val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>

<style scoped>
.active, .inactive-tab {
  border: none !important;
  border-radius: 0px !important;
}

.col-custom-radius {
  border-radius: 25px !important;
}

/* Estilos base para todos los links (pestañas) */
.nav-tabs .nav-link {
  margin-top: -20px;
  transition: all 0.3s ease;
  border: none !important;
  cursor: pointer;
  border-bottom: 3px solid transparent !important;
  color: #ffffff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: calc(100% + 20px) !important;
  width: 100% !important;
  text-align: center;
}

/* Estilos para la pestaña activa (seleccionada) */
.nav-tabs .nav-link.active {
  color: #25be14 !important;
  background-color: white !important;
}

/* Estilos para la pestaña inactiva */
.nav-tabs .nav-link.inactive-tab {
  border-radius: 25px 25px 0px 0px !important;
  background-color: #777777;
  color: #6c757d;
}

.nav-tabs .nav-link:hover {
  background-color: #f8f9fa;
}

.nav-item {
  background-color: #777777 !important;
  display: flex !important;
  flex: 1 !important;
}

/* Forzar reescritura del borde activo global de Vue/Bootstrap (El verde) */
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border-top: 3px solid #ffffff !important;
  border-right: 3px solid #ffffff !important;
  border-left: 3px solid #ffffff !important;
  border-bottom: none !important;
  border-radius: 25px 25px 0px 0px !important;
  box-shadow: none !important;
}
.nav-tabs .nav-item .nav-link.active::after {
  display: none !important;
}

/* Forzar reescritura del Hover global */
.nav-tabs .nav-item .nav-link:hover,
.nav-tabs .nav-item.show .nav-link:hover {
  color: #25be14 !important;
  border-radius: 25px 25px 0px 0px !important;
}
.nav-tabs .nav-item .nav-link:hover::after {
  display: none !important;
}

.nav-tabs {
  border-radius: 25px 25px 0% 0% !important;
  background-color: #777777 !important;
  display: flex !important;
  align-items: stretch !important;
}

.nav-tabs .nav-item:first-child {
  background-color: #ffffff00 !important;
  border-radius: 25px 0% 0% 0% !important;
}

.nav-tabs .nav-item:last-child {
  background-color: #ffffff00 !important;
  border-radius: 0% 25px 0% 0% !important;
}

.disabled-tab {
  opacity: 1 !important;
  cursor: not-allowed !important;
  pointer-events: none;
  filter: grayscale(100%);
}
</style>
